import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Box, Typography, Button, useMediaQuery } from '@mui/material';
// import './we_serve.css'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function Weserve({ isAdmin }) {
  const [imageData, setImageData] = useState([]);
  const [file, setFile] = useState(null);
  // const [isAdmin, setIsAdmin] = useState(true);

  const isSmallScreen = useMediaQuery('(max-width:450px)');
  const between = useMediaQuery('(min-width:450px) and (max-width:550px)')
  const isMediumScreen = useMediaQuery('(min-width:550px) and (max-width:1240px)');
  //const isLargeScreen = useMediaQuery('(min-width:1240px)');

  // Dynamic n and k values
  let n = isSmallScreen ? 3 : between ? 4 : isMediumScreen ? 6 : 8;
  let k = isSmallScreen ? 8 : between ? 6 : isMediumScreen ? 4 : 3;

  useEffect(() => {
    async function fetchImages() {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/weserve/images`);
        const data = await response.json();
        setImageData(data);
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    }

    fetchImages();
  }, []);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/weserve/upload`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const newImage = await response.json();
        setImageData((prevData) => [...prevData, newImage]);
        setFile(null);
      } else {
        console.error('Error uploading image');
      }
    } catch (error) {
      console.error('Error during upload:', error);
    }
  };

  // Carousel settings
  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  const chunkedImages = [];
  for (let i = 0; i < imageData.length; i += 24) {
    chunkedImages.push(imageData.slice(i, i + 24));
  }
  const handleDelete = async (id, filename) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/weserve/delete`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id, filename }),
      });

      if (response.ok) {
        setImageData((prevData) => prevData.filter((image) => image.image !== filename)); // Remove the image from state
      } else {
        console.error('Error deleting image');
      }
    } catch (error) {
      console.error('Error during deletion:', error);
    }
  };
  return (
    <Box
      sx={{
        width: '100%',
        // bgcolor: '#4b90c0',
        bgcolor: 'white',
        padding: 2,
        paddingBottom: 6,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ margin: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            color: 'black',
          }}
        >
          {isAdmin ? '' : 'We Serve'}
        </Typography>
      </Box>


      <Box sx={{ width: { xs: '85%', lg: '90%' }, marginLeft: { md: '0', lg: '0%' } }}>
        {/* File Upload */}
        {isAdmin && <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 2,
          }}
        >
          <input
            type="file"
            onChange={handleFileChange}
            accept="image/*"
            style={{ marginRight: 10 }}
          />
          <Button
            variant="contained"
            onClick={handleUpload}
            disabled={!file}
            sx={{ bgcolor: '#1976d2', color: 'white' }}
          >
            Add Image
          </Button>
        </Box>}
        {/* Image Slider */}
        <Slider {...settings}>
          {chunkedImages.map((group, groupIndex) => (
            <Box key={groupIndex} sx={{
              display: 'flex',
              padding: 0,
              justifyContent: 'center',
              alignItems: 'center',
              //  backgroundColor: 'yellow', 
              minHeight: '300px',
              height: '100%',
              position: 'relative'
            }}>
              {Array.from({ length: k }).map((_, rowIndex) => {
                //console.log('chunkedImages: '+group.length)
                if (!isAdmin && group.length < 24 && group.length > 0) {
                  group = group.concat(imageData.slice(0, 24 - group.length));
                }
                let rowImages = group.slice(rowIndex * n, rowIndex * n + n);
                return (
                  <Box
                    key={rowIndex}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      // backgroundColor: 'pink',
                      flexWrap: 'wrap',
                    }}
                  >
                    {rowImages.map((image, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          width: { xs: '60px', lg: '100px', md: '100px' },
                          margin: { xs: 1, lg: 2, md: 2 },
                        }}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            height: '100%',
                            bgcolor: 'white',
                            borderRadius: '4px',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            src={image.image}
                            alt={`We Serve - ${index + 1}`} // ✅ Descriptive but not redundant
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />

                        </Box>
                        {/* Delete button below the image */}
                        {isAdmin && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleDelete(image._id, image.image)}
                            sx={{
                              marginTop: 1,
                              fontSize: { xs: '0.5rem', lg: '0.7rem' },
                              width: '90%',
                            }}
                          >
                            Delete
                          </Button>
                        )}
                      </Box>
                    ))}
                  </Box>
                );
              })}
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
}
